import { RefreshCw, Plus, Sparkles } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/EmptyState";
import AssinaturaCard from "./AssinaturaCard";

// FIN-6 — Grid responsiva (1/2/3 cols) ou empty state.

export default function AssinaturasGrid({
  subscriptions,
  isLoading,
  onEdit,
  onDelete,
  onTalk,
  onCreate,
  onDetect,
  hasActiveFilter,
}) {
  if (!isLoading && subscriptions.length === 0) {
    return (
      <Card variant="elevated" className="glass-card py-12 px-6" data-testid="sub-grid-empty">
        <EmptyState
          icon={RefreshCw}
          title={hasActiveFilter ? "Nenhuma assinatura nesse filtro" : "Nenhuma assinatura cadastrada"}
          description={hasActiveFilter
            ? "Tente outro filtro ou volte pra Todas."
            : "Cadastre suas assinaturas pra acompanhar custos recorrentes — ou peça pro Nexo detectar nas suas transações."}
          action={!hasActiveFilter && (onCreate || onDetect) ? (
            <div className="flex items-center gap-2 flex-wrap justify-center">
              {onCreate && (
                <Button variant="primary" size="md" onClick={onCreate} data-testid="sub-empty-create">
                  <Plus className="w-4 h-4" /> Nova assinatura
                </Button>
              )}
              {onDetect && (
                <Button variant="ghost" size="md" onClick={onDetect} data-testid="sub-empty-detect"
                  className="text-status-warning hover:text-status-warning hover:bg-status-warning/10">
                  <Sparkles className="w-4 h-4" /> Detectar
                </Button>
              )}
            </div>
          ) : null}
        />
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-testid="sub-grid">
      {subscriptions.map(sub => (
        <AssinaturaCard
          key={sub.id}
          sub={sub}
          onEdit={onEdit}
          onDelete={onDelete}
          onTalk={onTalk}
        />
      ))}
    </div>
  );
}
